<div [ngClass]="'height-full flex flex-column ' + partner">
  <div class="main-layout flex-grow">
    <div class="error-content text-center padding-vertical-xxbig display-block">
      <div class="flex flex-justify-center">
        <open-svg-icon name="communication-alert" class="xmedium logo"></open-svg-icon>
      </div>
      <div class="margin-vertical-xmedium">
        <h1 class="margin-bottom-medium">Oops! something didn't go as planned</h1>
        <p>Rest assured, we're working to fix it as quickly as possible. </p>
        <p>You can check back later, we'll have everything up and running soon.</p>
      </div>
    </div>
  </div>
  
  <footer class="padding-medium">
    <div class="footer-links">
      <a id="terms" target="_blank" [href]="termsLink" class="margin-right-small">Terms &amp; Conditions</a>
      <a id="privacy" target="_blank" [href]="privacyLink">Privacy</a>
    </div>
  
    <div class="footer-logo">
      <open-svg-icon name="open-badge" class="badge"></open-svg-icon>
    </div>
  </footer>
</div>
